import { render, staticRenderFns } from "./NfeProductGrid.vue?vue&type=template&id=66f56456"
import script from "./NfeProductGrid.vue?vue&type=script&lang=js"
export * from "./NfeProductGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports